import React from "react";

interface IDefaultCardIndicator{
text: string;
}
const DefaultCardIndicator = ({ text }: IDefaultCardIndicator) => {
  return (
    <div className="flex items-center bg-gv-yellow-light text-[0.6rem] py-0.5 px-5 rounded-2xl text-gv-gold capitalize">
      {text}
    </div>
  );
};

export default DefaultCardIndicator;
